
export default function WelcomeDashboard() {
    return (
        <div>
            <div className="h-[80vh] flex justify-center items-center">
                <img src="https://images.unsplash.com/photo-1630450202872-e0829c9d6172?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80" class="mask mask-hexagon" alt="" />
            </div>
        </div>
    )
}
